import React from 'react';
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Hero from "../components/Hero"
import Layout from "../components/layout"

import Recent from '../components/Recent';


const ComponentName = ({ data: { blog, desktopImage, mobileImage } }) => (
    <Layout>
      <SEO
        title="Hizmetlerimiz | Konya İnşaat Merkezi | Ayazsan"
        description="Ayazsan İnşaat, müşteri memnuniyetinin yanında işçilik kalitesini ön plana çıkararak edindiği tecrübe ile Konya'da hizmet vermeye devam etmektedir."
      />
     <Hero
      title="Ayazsan İnşaat Hizmetleri"
      subtitle="Siz Sadece Hayal Edin Biz Yapalım"
      text="Boya badana, Asma Tavan, Metal Asma Tavan, Mutfak Tadilatı, Banyo Tadilatı, Ofis Tadilatı, Fabrika İnşaatı, Villa İnşaatı alanlarında Konya'da faaliyet gösteren aynı zamanda taşeron inşaat hizmetleri de yapmaktadır."
      desktop={desktopImage.childImageSharp.fluid}
      mobile={mobileImage.childImageSharp.fluid} />
        <Recent posts={blog.edges} />
    </Layout>
  )


export const homeQuery = graphql`
{
  desktopImage: file(relativePath: { eq: "projeler.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
  mobileImage: file(relativePath: { eq: "projeler-cm.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 500) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
  blog: allDatoCmsBlog(sort: { fields: [date], order: DESC }
  ) {
    edges {
      node {
        id
        title
        slug
        date(formatString: "Do MMMM, YYYY" locale:"tr")
        description
        image {
          fluid(maxWidth: 534, imgixParams: { fm: "jpg", auto: "compress" }) {
            ...GatsbyDatoCmsFluid_noBase64
          }
        }
      }
    }
  }
}
`

export default ComponentName
